import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '@grandvisionhq/carts-v2';
import '../../StepShipping/selectors.js';
import '@swc/helpers';
import 'lodash/isEmpty';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';
import { useExpressCheckoutLabels } from '../../hooks/common/use-express-checkout-labels.js';
import '@grandvisionhq/auth';
import '../../context/CheckoutSettings/context.js';
import '../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../operations/mutations/set-customer-details.js';
import '../../operations/mutations/set-service-store.js';
import '../../operations/mutations/set-shipping-method.js';
import '../../operations/mutations/set-shipping-state.js';
import '../../operations/mutations/create-apple-pay-session.js';
import '../../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/payments';
import '@grandvisionhq/analytics';
import '../../operations/fragments/checkout-mutation-result.js';
import '../../operations/fragments/cart-mutation-failures.js';
import '../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../operations/fragments/paypal-payment.js';
import '../../operations/fragments/saved-user-details.js';
import '../../operations/queries/get-checkout-state.js';
import '../../operations/queries/get-user-details.js';

const useGetExpressLabels = (paymentType)=>{
    const { getTitle  } = useExpressCheckoutLabels();
    const { getLabel , getFormattedLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            generic: {
                title: getLabel('checkout.generic.title')
            },
            yourDetails: getLabel('checkout.yourDetails'),
            billingAddress: getLabel('checkout.billingAddress'),
            paymentInProgress: getLabel('checkout.order.inprogress'),
            completed: {
                shipmentDetailsDelivery: getLabel('checkout.completed.shipmentDetails.delivery')
            },
            contactTitle: getLabel('checkout.contact.title'),
            shipmentAddress: getLabel('checkout.shipment.address'),
            paymentMethod: getTitle(paymentType),
            address: getLabel('checkout.summary.shipment.address'),
            differentDeliveryAddress: getLabel('checkout.shipment.differentDeliveryAddress'),
            nearestPickupMessage: getLabel('checkout.summary.shipment.nearestPickup.message'),
            implicitTerms: getFormattedLabel('checkout.disclaimer.conditions', {
                parseLink: true,
                openLinksInNewTab: true
            })
        })
    , [
        getLabel,
        getFormattedLabel,
        getTitle,
        paymentType
    ]);
    const deliveryLabels = React.useMemo(()=>({
            summary: {
                delivery: getLabel('checkout.summary.shipment.delivery'),
                deliveryExpress: getLabel('checkout.summary.shipment.deliveryExpress'),
                pickupStore: getLabel('checkout.summary.shipment.pickup'),
                pickupPoint: getLabel('checkout.summary.shipment.pickupPoint'),
                nearestPickup: getLabel('checkout.summary.shipment.nearestPickup'),
                address: getLabel('checkout.summary.shipment.address'),
                deliveryPremium: getLabel('checkout.summary.shipment.deliveryPremium'),
                deliveryResponsible: getLabel('checkout.summary.shipment.deliveryResponsible')
            }
        })
    , [
        getLabel
    ]);
    return {
        labels,
        summaryLabels: deliveryLabels
    };
};

export { useGetExpressLabels };
//# sourceMappingURL=use-get-express-labels.js.map
